/**
 * Generated by orval 🍺
 * Do not edit manually.
 * Internal API
 * OpenAPI spec version: v1
 */
import {
  useMutation,
  useQuery
} from '@tanstack/vue-query';
import type {
  DataTag,
  MutationFunction,
  QueryClient,
  QueryFunction,
  QueryKey,
  UseMutationOptions,
  UseMutationReturnType,
  UseQueryOptions,
  UseQueryReturnType
} from '@tanstack/vue-query';

import {
  computed,
  toValue,
  unref
} from 'vue';
import type {
  MaybeRefOrGetter
} from 'vue';

import type {
  AiDocumentQa,
  AiDocumentQaRequestInput,
  ListAiDocumentQaParams,
  PaginatedAiDocumentQas,
  SchemaValidationErrorResponse
} from '../../models';

import { axiosClient } from '../../../internalAxiosClient.ts';
import type { ErrorType } from '../../../internalAxiosClient.ts';




/**
 * @summary Create AI DocumentQa
 */
export const createDocumentQa = (
    aiDocumentQaRequestInput: MaybeRefOrGetter<AiDocumentQaRequestInput>,
 signal?: AbortSignal
) => {
      aiDocumentQaRequestInput = toValue(aiDocumentQaRequestInput);

      return axiosClient<AiDocumentQa>(
      {url: `/ai/document_qas`, method: 'POST',
      headers: {'Content-Type': 'application/json', },
      data: aiDocumentQaRequestInput, signal
    },
      );
    }




export const getCreateDocumentQaMutationKey = () => ['createDocumentQa'] as const;

export const getCreateDocumentQaMutationOptions = <TError = ErrorType<void>,
    TContext = unknown>(options?: { mutation?:UseMutationOptions<Awaited<ReturnType<typeof createDocumentQa>>, TError,CreateDocumentQaMutationVariables, TContext>, }
): UseMutationOptions<Awaited<ReturnType<typeof createDocumentQa>>, TError,CreateDocumentQaMutationVariables, TContext> => {

const mutationKey = getCreateDocumentQaMutationKey();
const {mutation: mutationOptions} = options ?
      options.mutation && 'mutationKey' in options.mutation && options.mutation.mutationKey ?
      options
      : {...options, mutation: {...options.mutation, mutationKey}}
      : {mutation: { mutationKey, }};




      const mutationFn: MutationFunction<Awaited<ReturnType<typeof createDocumentQa>>, CreateDocumentQaMutationVariables> = (props) => {
          const {data} = props ?? {};

          return  createDocumentQa(data,)
        }






  return  { mutationFn, ...mutationOptions }}

    export type CreateDocumentQaMutationResult = NonNullable<Awaited<ReturnType<typeof createDocumentQa>>>
    export type CreateDocumentQaMutationBody = AiDocumentQaRequestInput
    export type CreateDocumentQaMutationError = ErrorType<void>
    export type CreateDocumentQaMutationVariables = {data: AiDocumentQaRequestInput}

    /**
 * @summary Create AI DocumentQa
 */
export const useCreateDocumentQa = <TError = ErrorType<void>,
    TContext = unknown>(options?: { mutation?:UseMutationOptions<Awaited<ReturnType<typeof createDocumentQa>>, TError,CreateDocumentQaMutationVariables, TContext>, }
 , queryClient?: QueryClient): UseMutationReturnType<
        Awaited<ReturnType<typeof createDocumentQa>>,
        TError,
        CreateDocumentQaMutationVariables,
        TContext
      > => {
      return useMutation(getCreateDocumentQaMutationOptions(options), queryClient);
    }
    /**
 * @summary List of AI DocumentQa
 */
export const listAiDocumentQa = (
    params?: MaybeRefOrGetter<ListAiDocumentQaParams>,
 signal?: AbortSignal
) => {
      params = toValue(params);

      return axiosClient<PaginatedAiDocumentQas>(
      {url: `/ai/document_qas`, method: 'GET',
        params, signal
    },
      );
    }




export const getListAiDocumentQaQueryKey = (params?: MaybeRefOrGetter<ListAiDocumentQaParams>,) => {
    return [
    'ai','document_qas', ...(params ? [params] : [])
    ] as const;
    }


export const getListAiDocumentQaQueryOptions = <TData = Awaited<ReturnType<typeof listAiDocumentQa>>, TError = ErrorType<SchemaValidationErrorResponse | void>>(params?: MaybeRefOrGetter<ListAiDocumentQaParams>, options?: { query?:Partial<UseQueryOptions<Awaited<ReturnType<typeof listAiDocumentQa>>, TError, TData>>, }
) => {

const {query: queryOptions} = options ?? {};

  const queryKey =  getListAiDocumentQaQueryKey(params);



    const queryFn: QueryFunction<Awaited<ReturnType<typeof listAiDocumentQa>>> = ({ signal }) => listAiDocumentQa(params, signal);





   return  { queryKey, queryFn, ...queryOptions} as UseQueryOptions<Awaited<ReturnType<typeof listAiDocumentQa>>, TError, TData>
}

export type ListAiDocumentQaQueryResult = NonNullable<Awaited<ReturnType<typeof listAiDocumentQa>>>
export type ListAiDocumentQaQueryError = ErrorType<SchemaValidationErrorResponse | void>


/**
 * @summary List of AI DocumentQa
 */

export function useListAiDocumentQa<TData = Awaited<ReturnType<typeof listAiDocumentQa>>, TError = ErrorType<SchemaValidationErrorResponse | void>>(
 params?: MaybeRefOrGetter<ListAiDocumentQaParams>, options?: { query?:Partial<UseQueryOptions<Awaited<ReturnType<typeof listAiDocumentQa>>, TError, TData>>, }
 , queryClient?: QueryClient
 ): UseQueryReturnType<TData, TError> & { queryKey: DataTag<QueryKey, TData, TError> } {

  const queryOptions = getListAiDocumentQaQueryOptions(params,options)

  const query = useQuery(queryOptions, queryClient) as UseQueryReturnType<TData, TError> & { queryKey: DataTag<QueryKey, TData, TError> };

  query.queryKey = unref(queryOptions).queryKey as DataTag<QueryKey, TData, TError>;

  return query;
}






/**
 * @summary Delete AI DocumentQa
 */
export const deleteDocumentQa = (
    id: MaybeRefOrGetter<string>,
 signal?: AbortSignal
) => {
      id = toValue(id);

      return axiosClient<void>(
      {url: `/ai/document_qas/${id}`, method: 'DELETE', signal
    },
      );
    }




export const getDeleteDocumentQaMutationKey = () => ['deleteDocumentQa'] as const;

export const getDeleteDocumentQaMutationOptions = <TError = ErrorType<SchemaValidationErrorResponse | void>,
    TContext = unknown>(options?: { mutation?:UseMutationOptions<Awaited<ReturnType<typeof deleteDocumentQa>>, TError,DeleteDocumentQaMutationVariables, TContext>, }
): UseMutationOptions<Awaited<ReturnType<typeof deleteDocumentQa>>, TError,DeleteDocumentQaMutationVariables, TContext> => {

const mutationKey = getDeleteDocumentQaMutationKey();
const {mutation: mutationOptions} = options ?
      options.mutation && 'mutationKey' in options.mutation && options.mutation.mutationKey ?
      options
      : {...options, mutation: {...options.mutation, mutationKey}}
      : {mutation: { mutationKey, }};




      const mutationFn: MutationFunction<Awaited<ReturnType<typeof deleteDocumentQa>>, DeleteDocumentQaMutationVariables> = (props) => {
          const {id} = props ?? {};

          return  deleteDocumentQa(id,)
        }






  return  { mutationFn, ...mutationOptions }}

    export type DeleteDocumentQaMutationResult = NonNullable<Awaited<ReturnType<typeof deleteDocumentQa>>>

    export type DeleteDocumentQaMutationError = ErrorType<SchemaValidationErrorResponse | void>
    export type DeleteDocumentQaMutationVariables = {id: string}

    /**
 * @summary Delete AI DocumentQa
 */
export const useDeleteDocumentQa = <TError = ErrorType<SchemaValidationErrorResponse | void>,
    TContext = unknown>(options?: { mutation?:UseMutationOptions<Awaited<ReturnType<typeof deleteDocumentQa>>, TError,DeleteDocumentQaMutationVariables, TContext>, }
 , queryClient?: QueryClient): UseMutationReturnType<
        Awaited<ReturnType<typeof deleteDocumentQa>>,
        TError,
        DeleteDocumentQaMutationVariables,
        TContext
      > => {
      return useMutation(getDeleteDocumentQaMutationOptions(options), queryClient);
    }
    /**
 * @summary AI DocumentQa Details
 */
export const getAiDocumentQa = (
    id: MaybeRefOrGetter<string>,
 signal?: AbortSignal
) => {
      id = toValue(id);

      return axiosClient<AiDocumentQa>(
      {url: `/ai/document_qas/${id}`, method: 'GET', signal
    },
      );
    }




export const getGetAiDocumentQaQueryKey = (id: MaybeRefOrGetter<string>,) => {
    return [
    'ai','document_qas',id
    ] as const;
    }


export const getGetAiDocumentQaQueryOptions = <TData = Awaited<ReturnType<typeof getAiDocumentQa>>, TError = ErrorType<SchemaValidationErrorResponse | void>>(id: MaybeRefOrGetter<string>, options?: { query?:Partial<UseQueryOptions<Awaited<ReturnType<typeof getAiDocumentQa>>, TError, TData>>, }
) => {

const {query: queryOptions} = options ?? {};

  const queryKey =  getGetAiDocumentQaQueryKey(id);



    const queryFn: QueryFunction<Awaited<ReturnType<typeof getAiDocumentQa>>> = ({ signal }) => getAiDocumentQa(id, signal);





   return  { queryKey, queryFn, enabled: computed(() => toValue(id) !== null && toValue(id) !== undefined), ...queryOptions} as UseQueryOptions<Awaited<ReturnType<typeof getAiDocumentQa>>, TError, TData>
}

export type GetAiDocumentQaQueryResult = NonNullable<Awaited<ReturnType<typeof getAiDocumentQa>>>
export type GetAiDocumentQaQueryError = ErrorType<SchemaValidationErrorResponse | void>


/**
 * @summary AI DocumentQa Details
 */

export function useGetAiDocumentQa<TData = Awaited<ReturnType<typeof getAiDocumentQa>>, TError = ErrorType<SchemaValidationErrorResponse | void>>(
 id: MaybeRefOrGetter<string>, options?: { query?:Partial<UseQueryOptions<Awaited<ReturnType<typeof getAiDocumentQa>>, TError, TData>>, }
 , queryClient?: QueryClient
 ): UseQueryReturnType<TData, TError> & { queryKey: DataTag<QueryKey, TData, TError> } {

  const queryOptions = getGetAiDocumentQaQueryOptions(id,options)

  const query = useQuery(queryOptions, queryClient) as UseQueryReturnType<TData, TError> & { queryKey: DataTag<QueryKey, TData, TError> };

  query.queryKey = unref(queryOptions).queryKey as DataTag<QueryKey, TData, TError>;

  return query;
}






